import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { DatePicker, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Box, Flex, Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import { FichaContactologicaFormulario } from './fichaContactologica.form';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import ReadOnly from '../../shared/components/dataEntry/ReadOnly';
import EditableTable from '../../shared/containers/EditableTable';
import {
  columns_1, columns_2, columns_3, columns_4, columns_5,
} from './contactologiaTables';
import {isNumeric} from "../../../helpers/common.helper";

export function FichaContactologicaFormOtros({
  watch,
  create,
  form,
  onSetValue,
  datosGraduacion,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo } = params;
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const tiendas = useSelector(state => state.core.tiendas);
  const sagas = useSelector(state => state.sagas);
  const datosGraduacionOriginal = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica);
  const tiendaCreate = create ? tiendas.find(e => e.id === tiendaId) : null;
  const tiendaCreateName = create && tiendaCreate ? tiendaCreate.nombre : null;
  const { getFieldDecorator } = form;
  const tipo_ficha = datosGraduacion && datosGraduacion.tipo_ficha ? datosGraduacion.tipo_ficha : 'P';
  const otros_datos = datosGraduacion && datosGraduacion.otros_datos_contactologicos;
  const prueba_lentillas = datosGraduacion && datosGraduacion.pruebas_lentillas;
  const dataSource_4 = [
    {
      key: '1',
      ojo: 'Dcho.',
      diametro: otros_datos && otros_datos.ojo_derecho?.diametro,
      diametrozo: otros_datos && otros_datos.ojo_derecho?.diametro_zo,
      radio: otros_datos && otros_datos.ojo_derecho?.radio,
      tipoDeLente: otros_datos && otros_datos.ojo_derecho?.tipo_lente,
      // acciones: 'Buscar lente | Reponer',

    },
    {
      key: '2',
      ojo: 'Izdo.',
      diametro: otros_datos && otros_datos.ojo_izquierdo?.diametro,
      diametrozo: otros_datos && otros_datos.ojo_izquierdo?.diametro_zo,
      radio: otros_datos && otros_datos.ojo_izquierdo?.radio,
      tipoDeLente: otros_datos && otros_datos.ojo_izquierdo?.tipo_lente,
      // acciones: 'Buscar lente | Reponer',

    },

  ];
  const dataSource_5 = prueba_lentillas ? prueba_lentillas.map((e, i) => ({
    key: i,
    grad: e?.codigo,
    suc: e?.tienda_id,
    num: e?.numero,
    fecha: e?.fecha?.split(' ')[0],
    resumen_oi: e?.resumen_ojo_izquierdo,
    resumen_od: e?.resumen_ojo_derecho,
  })) : [];
  const handleTableDataChange = ({ rowKey, newRow }, type) => {

    switch (type) {
      case 'table-otros-datos':
        let copiaOtrosDatos = null;
        const nuevoDiametro = newRow.diametro;
        if(!isNumeric(nuevoDiametro) && nuevoDiametro !== '' && nuevoDiametro !== null && nuevoDiametro !== undefined) return;
        const nuevoDiametroZo = newRow.diametrozo;
        if(!isNumeric(nuevoDiametroZo) && nuevoDiametroZo !== '' && nuevoDiametroZo !== null && nuevoDiametroZo !== undefined) return;
        const nuevoRadio = newRow.radio;
        if(!isNumeric(nuevoRadio) && nuevoRadio !== '' && nuevoRadio !== null && nuevoRadio !== undefined) return;
        if (rowKey === '1') {
          const ojo_derecho = {
            diametro: nuevoDiametro !== '' && nuevoDiametro !== null && nuevoDiametro !== undefined ? Math.abs(parseFloat(nuevoDiametro)).toFixed(2) : null,
            diametro_zo: nuevoDiametroZo !== '' && nuevoDiametroZo !== null && nuevoDiametroZo !== undefined ? Math.abs(parseFloat(nuevoDiametroZo)).toFixed(2) : null,
            radio: nuevoRadio !== '' && nuevoRadio !== null && nuevoRadio !== undefined && parseFloat(nuevoRadio) >= 0.0 && parseFloat(nuevoRadio) < 10.0 ? Math.abs(parseFloat(nuevoRadio)).toFixed(2) : null,
            tipo_lente: newRow.tipoDeLente,
          };
          copiaOtrosDatos = datosGraduacion.otros_datos_contactologicos ? {
            ...datosGraduacion.otros_datos_contactologicos,
            ojo_derecho,
          } : { ojo_derecho };
        } else {
          const ojo_izquierdo = {
            diametro: nuevoDiametro !== '' && nuevoDiametro !== null && nuevoDiametro !== undefined ? Math.abs(parseFloat(nuevoDiametro)).toFixed(2) : null,
            diametro_zo: nuevoDiametroZo !== '' && nuevoDiametroZo !== null && nuevoDiametroZo !== undefined ? Math.abs(parseFloat(nuevoDiametroZo)).toFixed(2) : null,
            radio: nuevoRadio !== '' && nuevoRadio !== null && nuevoRadio !== undefined && parseFloat(nuevoRadio) >= 0.0 && parseFloat(nuevoRadio) < 10.0 ? Math.abs(parseFloat(nuevoRadio)).toFixed(2) : null,
            tipo_lente: newRow.tipoDeLente,
          };
          copiaOtrosDatos = datosGraduacion.otros_datos_contactologicos ? {
            ...datosGraduacion.otros_datos_contactologicos,
            ojo_izquierdo,
          } : { ojo_izquierdo };
        }
        onSetValue({ otros_datos_contactologicos: copiaOtrosDatos }, {});
        break;
      case 'table-pruebas-lentillas':
        let copiaPruebaLentillas = null;
        if (rowKey === '1') {
          const ojo_derecho = {
            codigo: newRow.grad,
            tienda_id: newRow.suc,
            numero: newRow.num,
            fecha: newRow.fecha,
            resumen_ojo_derecho: newRow.resumen,
            resumen_ojo_izquierdo: datosGraduacion.pruebas_lentillas?.resumen_ojo_izquierdo,

          };
          copiaPruebaLentillas = datosGraduacion.pruebas_lentillas ? {
            ...datosGraduacion.pruebas_lentillas,
            ...ojo_derecho,
          } : { ...ojo_derecho };
        } else {
          const ojo_izquierdo = {
            codigo: newRow.grad,
            tienda_id: newRow.suc,
            numero: newRow.num,
            fecha: newRow.fecha,
            resumen_ojo_izquierdo: newRow.resumen,
            resumen_ojo_derecho: datosGraduacion.pruebas_lentillas?.resumen_ojo_derecho,

          };
          copiaPruebaLentillas = datosGraduacion.pruebas_lentillas ? {
            ...datosGraduacion.pruebas_lentillas,
            ...ojo_izquierdo,
          } : { ...ojo_izquierdo };
        }
        onSetValue({ pruebas_lentillas: copiaPruebaLentillas }, {});
        break;
      default:
        break;
    }
  };
  return (
    <>
      <Text fontFamily="Open Sans" color="#3E3E3C" fontWeight="600" fontSize="16px" mt="16px" translationId="ficha_contactologica.otros_datos_contactologicos" />
      <EditableTable
        mt="16px"
        readOnly={watch}
        size="middle"
        basic
        rowSelection={false}
        className="table-otros-datos"
        onRowChange={data => handleTableDataChange(data, 'table-otros-datos')}
        dataSource={dataSource_4}
        columns={columns_4}
        pagination={false}
      />
      {!create && tipo_ficha === 'D'
      && (
      <>
        <Text fontFamily="Open Sans" color="#3E3E3C" fontWeight="600" fontSize="16px" mt="16px" translationId="ficha_contactologica.pruebas_lentillas" />
        <EditableTable
          mt="16px"
          readOnly={watch}
          size="middle"
          basic
          rowSelection={false}
          className="table-pruebas-lentillas"
          onRowChange={data => handleTableDataChange(data, 'table-pruebas-lentillas')}
          dataSource={dataSource_5}
          columns={columns_5}
          pagination={false}
        />
      </>
      )
      }
      <Text fontFamily="Open Sans" color="#3E3E3C" fontWeight="600" fontSize="16px" mt="16px" translationId="ficha_contactologica.observaciones" />
      <ReadOnly condition={watch}>
        <TextArea disabled={watch} placeholder="Escriba aquí..." value={datosGraduacion && datosGraduacion.observaciones} onChange={e => onSetValue({ observaciones: e.target.value }, {})} style={{ marginTop: '16px' }} />
      </ReadOnly>
    </>
  );
}
